import React from 'react';

import './Spinner.css';

const Spinner = (props) => {
  return <div className="loader">Loading...</div>;
}

export default Spinner;
